import React from 'react';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import { useLifecycleBoards } from '@/modules/LifecycleBoard';
import type LifecycleBoard from '@/types/LifecycleBoard';

function ColumnValue({ value = [] }: { value: string[] }) {
  const { data }: { data?: LifecycleBoard[] } = useLifecycleBoards();
  const cols = React.useMemo(
    () => (data || []).map(({ columns }) => columns).flat(),
    [data],
  );

  return data ? (
    <span>
      {value
        .reduce<string[]>((arr, columnId) => {
          const columnTitle = cols.find(
            (column) => columnId === column.columnId,
          )?.columnTitle;
          return columnTitle ? [...arr, columnTitle] : arr;
        }, [])
        .join(', ')}
    </span>
  ) : null;
}

export default ColumnValue;
